import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs';
import { IEmployeeRole } from 'src/app/employee/employee-roles';
import { EmployeeRoleService } from 'src/app/employee/services/employee-role.service';
import { NameValidators } from 'src/app/shared/validators/name.validators';

@Component({
    selector: 'app-employee-roles',
    templateUrl: './employee-roles.component.html',
    styleUrls: ['./employee-roles.component.css'],
    standalone: false
})
export class EmployeeRolesComponent implements OnInit {

  constructor(
    private route : ActivatedRoute,
    private employeeRoleService : EmployeeRoleService
  ) { }

  employeeRoles : IEmployeeRole[] = [];
  public formGroup!: UntypedFormGroup;
  private editedRowIndex!: number;



  ngOnInit(): void {
    this.employeeRoles = this.route.snapshot.data.employeeRoles as IEmployeeRole[];
  }

  updateList(){
    this.employeeRoleService.listEmployeeRoleRoles({pageNumber: 0, pageSize: 999999})
    .pipe(first())
    .subscribe(response => {
      this.employeeRoles = response.data;
    })
  }

  addHandler({ sender }){
    this.closeEditor(sender);

    this.formGroup = new UntypedFormGroup({
      name: new UntypedFormControl(null, NameValidators(() => this.employeeRoles.map(r => r.name), 75, true)),
    });

    sender.addRow(this.formGroup);
  }

  editHandler({ sender, rowIndex, dataItem }){
    this.closeEditor(sender);

    this.formGroup = new UntypedFormGroup({
      name: new UntypedFormControl(dataItem.name,
        NameValidators(() => this.employeeRoles.filter(r => r.id !== dataItem.id).map(r => r.name), 75, true)),
    });

    this.editedRowIndex = rowIndex;

    sender.editRow(rowIndex, this.formGroup);
  }

  public cancelHandler({ sender, rowIndex }) {
    this.closeEditor(sender, rowIndex);
  }

  public saveHandler(event) {
    const id = event.dataItem.id ?? null;
    const request: any = {
      name: event.formGroup.value.name?.trim(),
      id,
    }

    const save$ = id
      ? this.employeeRoleService.updateEmployeeRoleRole(request)
      : this.employeeRoleService.addEmployeeRoleRole(request);

    // Close the row only on success, so the input survives a rejected save (errors are shown by the interceptor).
    save$.subscribe(() => {
      event.sender.closeRow(event.rowIndex);
      this.updateList();
    });
  }

  private closeEditor(grid, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex);
    this.editedRowIndex = undefined;
    this.formGroup = undefined;
  }

  deletionDialogOpened = false;
  private itemToDelete: { id: string } | null = null;

  public removeHandler({ dataItem }) {
    this.itemToDelete = dataItem;
    this.deletionDialogOpened = true;
  }

  public deleteConfirmed() {
    const dataItem = this.itemToDelete;
    this.itemToDelete = null;
    if (!dataItem) return;
    this.employeeRoleService.deleteEmployeeRoleRole(dataItem.id)
    .subscribe(response => {
      this.updateList();
    });;
  }

}
